import { useTranslation } from 'react-i18next';
import PermissionGate from '../../components/PermissionGate';

const Header = ({ canCreateClaim, history, userRole, claims,S }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.8)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
          {t('screens.claimsScreen.operations')}
          <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke={S.textMuted} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <polyline points='9 18 15 12 9 6' />
          </svg>
          <span style={{ color: S.textPrimary, fontWeight: 500 }}>{t('screens.claimsScreen.breadcrumbClaims')}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('screens.claimsScreen.title')}</div>
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <PermissionGate resource='claims' action='create'>
          <button
            onClick={() => history.push('/claims/new')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 20px',
              background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#fff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
              <line x1='12' y1='5' x2='12' y2='19' />
              <line x1='5' y1='12' x2='19' y2='12' />
            </svg>
            {t('screens.claimsScreen.newClaim')}
          </button>
        </PermissionGate>
        <button
          onClick={() => {
            const headers = [
              t('screens.claimsScreen.csvClaimNumber',{defaultValue:'Claim #'}),
              t('screens.claimsScreen.csvClaimant',{defaultValue:'Claimant'}),
              t('screens.claimsScreen.csvCompany',{defaultValue:'Company'}),
              t('screens.claimsScreen.csvProduct',{defaultValue:'Product'}),
              t('screens.claimsScreen.csvStatus',{defaultValue:'Status'}),
              t('screens.claimsScreen.csvPriority',{defaultValue:'Priority'}),
              t('screens.claimsScreen.csvAssignedTo',{defaultValue:'Assigned To'}),
              t('screens.claimsScreen.csvLastUpdated',{defaultValue:'Last Updated'}),
            ];
            const rows = claims.map(c => [c.id, c.claimant, c.company, c.lob, c.status, c.priority, c.assigned || '', c.updated]);
            const csv = [headers, ...rows].map(r => r.map(v => `"${String(v || '').replace(/"/g, '""')}"`).join(',')).join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `claims-${new Date().toISOString().slice(0, 10)}.csv`;
            a.click();
            URL.revokeObjectURL(url);
          }}
          style={{
            padding: '10px 16px',
            background: S.bgCard,
            border: `1px solid ${S.borderLight}`,
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 500,
            color: S.textSecondary,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke={S.textMuted} strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
            <polyline points='7 10 12 15 17 10' />
            <line x1='12' y1='15' x2='12' y2='3' />
          </svg>
          {t('screens.claimsScreen.export')}
        </button>
        <div style={{ position: 'relative', cursor: 'pointer', padding: 8 }}>
          <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke={S.textMuted} strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9' />
            <path d='M13.73 21a2 2 0 0 1-3.46 0' />
          </svg>
          <span style={{ position: 'absolute', top: 4, right: 4, width: 8, height: 8, borderRadius: '50%', background: '#ef4444', border: '2px solid #fff' }} />
        </div>
      </div>
    </header>
  );
};

export default Header;
